import { askPermission, subscribeUser, unsubscribeUser } from 'utils/sw';
import { parseRequestOptions } from '../utils/fetch';
import { webPushUrl, publicVapidKey } from '../config';

const requestNotificationPermission = () => {
  return askPermission();
};

const subscribeToNotifications = () => {
  const url = `${webPushUrl}/subscribe`;
  const { headers } = parseRequestOptions({ request: {} });

  return subscribeUser({ url, headers, publicVapidKey });
};

const unsubscribeFromNotifications = () => {
  return unsubscribeUser();
};

export { requestNotificationPermission, subscribeToNotifications, unsubscribeFromNotifications };
